export default __webpack_public_path__ + "flag-es-icon.svg";